module.exports = __webpack_public_path__ + "static/media/wm_bg_move.732af1b0.webp";